import { useState, useCallback } from 'react';
import Header from '../../../shared/Header/Header';
import Footer from '../../../shared/Footer/Footer';
import SectionHeader from '../../../layouts/showcaseLayouts/Section/SectionHeader/SectionHeader';
import BackButton from '../../../shared/backButton/BackButton';
import SectionBody from '../../../layouts/showcaseLayouts/Section/SectionBody/SectionBody';
import VideoCarousel from '../../../showcase/VideoCarousel/VideoCarousel';
import useIsLTE650 from '../../../../hooks/useIsLTE650';
import Popup from '../../../shared/Popup/Popup';
import FeedbackContent from '../../../shared/Popup/content/feedback/Feedback';
import './hotelProductsPage.scss';

const HotelProductsPage: React.FC = () => {
    const isMobile = useIsLTE650(650);
    const [isOpen, setOpen] = useState(false);
    const handleOpen = useCallback(() => setOpen(true), []);
    const handleClose = useCallback(() => setOpen(false), []);

    return (
        <div className="hotelProductsPage">
            <Header isMobile={isMobile} />
            <div className="hotelProductsPage_headerWrapper">
                <BackButton absolute />
                <SectionHeader title={'Продукция для гостиниц'} />
            </div>
            <SectionBody>
                <>
                    <div className="hotelProductsPage__videoBox">
                        <VideoCarousel />
                        <p className="hotelProductsPage__videoBox_textAbsolute hotelProductsPage__videoBox_textAbsolute_top">
                            Наша продукция отличается превосходным качеством сегмента premium и современным стильным дизайном.
                        </p>
                        <p className="hotelProductsPage__videoBox_textAbsolute hotelProductsPage__videoBox_textAbsolute_bottom">
                            Мы предлагаем уникальный сервис, который поможет наполнить отели высококачественными подушками и одеялами. Ваши клиенты будут спать как
                            младенцы под одеялами С. Габай и на воздушных подушках нашей марки.
                        </p>
                    </div>
                    <div className="hotelProductsPage__contentBox">
                        <p className="hotelProductsPage__contentBox_text">
                            Подробную информацию об ассортименте вы можете получить у специалистов отдела по работе с отелями путем{' '}
                            <button className="hotelProductsPage__contentBox_text_button" type="button" aria-haspopup="dialog" onClick={handleOpen}>
                                обратной связи
                            </button>
                        </p>
                    </div>
                </>
            </SectionBody>
            <Footer isMobile={isMobile} />
            <Popup isOpen={isOpen} onClose={handleClose}>
                <FeedbackContent />
            </Popup>
        </div>
    );
};

export default HotelProductsPage;
